import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import {
  getProveedores,
  showModal,
  getProveedoresExportar,
} from "../../store/actions/proveedores";
import { XlsExport } from "../../components/XlsExport";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import InputField from "../../components/InputField";

export const BuscarProveedor = () => {
  const pageSize = useSelector((state) => state.proveedores.pageSize);
  const isLoading = useSelector((state) => state.proveedores.isLoading);
  const exportando = useSelector((state) => state.proveedores.exportando);

  const dispatch = useDispatch();

  const initialValues = {
    search: ''
  };

  const { control, handleSubmit, reset, getValues, errors } = useForm({
    defaultValues: initialValues,
  });

  const onSubmit = (data) => {
    console.log(data);
    dispatch(
      getProveedores({ page: 1, pageSize, dataBuscar: data, buscando: true })
    );
  };

  const onCleanSearch = (e) => {
    dispatch(
      getProveedores({
        page: 1,
        pageSize,
        buscando: true,
      })
    );
    reset(initialValues);
  };

  const onExportar = () => {
    const dataBuscar = getValues();
    dispatch(getProveedoresExportar({ dataBuscar }));
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <InputField
              label="Busqueda"
              name="search"
              type="text"
              control={control}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={isLoading}
            >
              Buscar
            </Button>{" "}
            <Button
              variant="outlined"
              color="primary"
              onClick={(e) => onCleanSearch(e)}
            >
              Limpiar Busqueda
            </Button>{" "}
            <Button
              variant="outlined"
              color="primary"
              onClick={() => dispatch(showModal())}
            >
              Nuevo Proveedor
            </Button>{" "}
            <Button variant="outlined" color="primary" onClick={onExportar}>
              Exportar
            </Button>
          </Grid>
        </Grid>
      </form>
      {exportando && <XlsExport title="Proveedores" />}
    </>
  );

};
